import { render, staticRenderFns } from "./PerformanceChart.vue?vue&type=template&id=5b900180"
import script from "./PerformanceChart.vue?vue&type=script&lang=js"
export * from "./PerformanceChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports